import React from 'react';
import LoadFailure from './LoadFailure';
import './AppFailure.scss';

export default function AppFailure({ onRetry = () => window.location.reload() }) {
  return <main className="app-failure">
    <LoadFailure onRetry={onRetry} />
  </main>;
}
